// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5d5944f0","845":"44135919"}[chunkId] + ".chunk.js";
};